// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'

export * from 'echarts/src/echarts'
import 'echarts/map/js/china'

import '../static/font/iconfont.css'
import './styles/border.css'
import './styles/reset.css'
import './styles/index.css'
import './permission'
import './author'
// import vueCity  fro  m "vue-city-select" 
import './components/Toast/index.css';
import Toast from './components/Toast/index';
Vue.use(Toast);
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js